import { createFileRoute } from '@tanstack/react-router'
import UserHomepageDashboard from '@dashboard/UserHomepageDashboard'

export const Route = createFileRoute('/_auth/')({
  component: RouteComponent,
})

function RouteComponent() {
  return <UserHomepageDashboard />
}
